import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FemaleIcon from '@mui/icons-material/Female';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

export const categories = [
  {
    name: 'all',
    icon: <HomeIcon />,
  },
  
  {
    name: 'music',
    icon: <MusicNoteIcon />,
  },

  {
    name: 'films',
    icon: <OndemandVideoIcon />,
  },
  {
    name: 'gaming',
    icon: <SportsEsportsIcon />,
  },
  {
    name: 'live',
    icon: <LiveTvIcon />,
  },
  {
    name: 'learning',
    icon: <SchoolIcon />,
  },
  {
    name: 'sport',
    icon: <FitnessCenterIcon />,
  },
  {
    name: 'fashion',
    icon: <FemaleIcon />,
  },
  {
    name: 'beauty',
    icon: <FemaleIcon />,
  },
  {
    name: 'podcasts',
    icon: <GraphicEqIcon />,
  },
  {
    name: 'comedy',
    icon: <TheaterComedyIcon />,
  },
  {
    name: 'gyms',
    icon: <FitnessCenterIcon />,
  },
  {
    name: 'crypto',
    icon: <DeveloperModeIcon />,
  },
  {
    name: 'coding',
    icon: <DeveloperModeIcon />,
  },
];
